import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseURL, frontendURL } from "../config";
// import { Link, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from "react-router-dom";
// import LinkButtonSolid from '../Components/LinkButtonSolid'
import LPcontactUsForm from "../Components/LPcontactUsForm";
// import LPviewByAssembly from '../Components/LPviewByAssembly'
import LPviewByDocument from "../Components/LPviewByDocument";
import EqidPartsStore from "../Components/EqidPartsStore";
import { LPskeletonLoading } from "../Components/LandingPageComponents";
import ButtonSolid from "../Components/ButtonSolid";
import Popup from "../Components/Popup";
import ButtonOutline from "../Components/ButtonOutline";
import InputField from "../Components/InputField";
import { RightArrowIcon } from "../Components/Icons";
import { isValidEmail } from "../utils/validators";
import toast from "react-hot-toast";

const EqidTileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="w-6 h-6 text-[#131F38]">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
    <path d="M14 14h3v3h-3zM20 14v3M17 20h4M14 20h1" />
  </svg>
);

const PartsTileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="w-6 h-6 text-[#131F38]">
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.2 5.2l2.1 2.1M16.7 16.7l2.1 2.1M18.8 5.2l-2.1 2.1M7.3 16.7l-2.1 2.1" />
  </svg>
);

function LandingPage() {
  const [activeTab, setActiveTab] = useState("eqid");
  const [headerData, setHeaderData] = useState("");
  const [fetchingHeaderData, setFetchingHeaderData] = useState(true);
  const [modsId, setModsId] = useState();
  const [sendDesktopLink, setSendDesktopLink] = useState(false);
  const [urlEmail, setUrlEmail] = useState("");
  const [error, setError] = useState("");
  const [sendingData, setSendingData] = useState(false)
  const [initialSubmit, setInitialSubmit] = useState(true)
  const navigate = useNavigate();
  const { qr_id } = useParams();

  useEffect(() => {
    const fetchHeaderData = async (param) => {
      try {
        setFetchingHeaderData(true);
        const response = await axios.get(
          `${baseURL}/mods/getLandingPageDetails/${param}`,
          {
            headers: {
              "ngrok-skip-browser-warning": "any",
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setModsId(response.data.data.modsData.id);
        setHeaderData(response.data.data);
        // setUserEmail(response.data.data.customer_data.email);
      } catch (error) {
        console.error("Error:", error);
        navigate(`/eqid_notFound/${param}`);
      } finally {
        setFetchingHeaderData(false);
      }
    };

    fetchHeaderData(qr_id);
  }, [qr_id, navigate]);

  // const moveToContacts = () => {
  //   const MOcontactForm = document.getElementById("MOcontactForm");
  //   if (MOcontactForm) {
  //     MOcontactForm.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleChange = (input) => {
    setUrlEmail(input);
    if (!initialSubmit) {
      validateEmail(input);
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setError("Please add Email Address");
      return false;
    } else if (!isValidEmail(email)) {
      setError("Please add a valid Email Address");
      return false;
    } else {
      setError("");
      return true;
    }
  };

  const emailSubmit = async () => {
    setInitialSubmit(false);
    const validEmail = validateEmail(urlEmail);

    if (validEmail) {
      try {
        setSendingData(true);
        await axios.post(`${baseURL}/mods/continueToDesktop`, {
          email: urlEmail,
          eqid_link: `${frontendURL}/eqid/${qr_id}`,
        });
        toast.success("Email Sent Successfully");
        setUrlEmail("");
        setInitialSubmit(false);
        setSendDesktopLink(false)
      } catch (error) {
        toast.error("Something went wrong: Please try again later");
      } finally {
        setSendingData(false);
      }
    }
  };

  const serialNumber = headerData && headerData["modsData"] ? headerData["modsData"]["serial_number"] : "";

  return (
    <main className="bg-[#F4F5F8] min-h-screen">
      <nav className="bg-white min-h-[76px] md:min-h-[65px] flex justify-between items-center gap-3 pt-4 pb-2 px-3 md:px-4 border-b border-[#D9DDE6]">
        <a
          href={"https://www.choicebagging.com/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="h-auto w-[160px] md:w-[135px]"
            src="/CHOICE-BAGGING-NEW-LOGO-300x93-corrected-2.png"
            alt="Company Logo"
          />
        </a>
        {serialNumber && (
          <div className="text-right border rounded-md px-4 py-2 bg-slate-100">
            <span className="block text-[10px] font-bold tracking-widest text-[#8E9AAF]">
              SERIAL NO
            </span>
            <span className="block text-sm md:text-base font-bold text-[#131F38] font-mono">
              {serialNumber}
            </span>
          </div>
        )}
      </nav>

      <section className="bg-[#131F38] text-white px-4 pt-[30px] pb-[34px]">
        <div className="max-w-[1280px] mx-auto">
          <h1 className="text-2xl md:text-[28px] font-bold mb-1.5 tracking-tight">
            Parts &amp; service for your equipment
          </h1>
          <p className="text-[#A9B4C7] text-sm md:text-base max-w-[62ch]">
            Everything for serial {serialNumber || "..."} — manuals, drawings and service history, plus a parts store to build a quote.
          </p>
        </div>
      </section>

      <div className="border-b border-[#D9DDE6]">
        <div className="max-w-[1280px] mx-auto px-4">
          <div
            role="tablist"
            aria-label="Portal sections"
            className="max-w-[760px] -mt-[18px] pb-6 grid grid-cols-1 sm:grid-cols-2 gap-4 relative z-10"
          >
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "eqid"}
              onClick={() => setActiveTab("eqid")}
              className={`text-left bg-white border rounded-none p-4 flex flex-col gap-1.5 border-t-4 transition-colors ${activeTab === "eqid"
                ? "border-[#131F38] border-t-[#C9A227]"
                : "border-[#D9DDE6] border-t-[#D9DDE6] hover:border-[#B4BCCB]"
                }`}
            >
              <EqidTileIcon />
              <span className="font-bold text-base text-[#131F38]">EQID</span>
              <span className="text-sm text-[#5B6679]">
                This machine's EQID page — manuals, drawings, tutorials and service history.
              </span>
              {serialNumber && (
                <span className="mt-1.5 self-start text-xs font-bold text-[#131F38] bg-[#F4F5F8] border border-[#E8EBF1] px-2 py-0.5">
                  Serial {serialNumber}
                </span>
              )}
            </button>

            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "parts"}
              onClick={() => setActiveTab("parts")}
              className={`text-left bg-white border rounded-none p-4 flex flex-col gap-1.5 border-t-4 transition-colors ${activeTab === "parts"
                ? "border-[#131F38] border-t-[#C9A227]"
                : "border-[#D9DDE6] border-t-[#D9DDE6] hover:border-[#B4BCCB]"
                }`}
            >
              <PartsTileIcon />
              <span className="font-bold text-base text-[#131F38]">Parts Store</span>
              <span className="text-sm text-[#5B6679]">
                Search the parts index and build a quote request — no payment needed.
              </span>
            </button>
          </div>
        </div>
      </div>

      {activeTab === "eqid" && (
        <div className="max-w-[1280px] mx-auto px-4 pb-16 pt-6">
          <section className="bg-white border border-[#D9DDE6]">
            <div className="bg-[#131F38] text-white px-6 py-8 md:px-8 md:py-9">
              <div className="grid grid-cols-1 lg:grid-cols-[1fr_230px] gap-9 items-start">
                <div>
                  <div className="flex items-baseline gap-3 flex-wrap mb-5">
                    <h2 className="m-0 text-2xl font-extrabold tracking-[2px]">EQID</h2>
                    <span className="text-[#A9B4C7] text-sm">
                      Choice Bagging <b className="text-white font-bold">EQ</b>uipment <b className="text-white font-bold">ID</b> Tool
                    </span>
                  </div>

                  {fetchingHeaderData ? (
                    <div className="mb-3 w-full max-w-72">
                      <LPskeletonLoading max_width={"max-w-72"} />
                    </div>
                  ) : (
                    <h3 className="m-0 mb-3 text-2xl md:text-[30px] font-extrabold text-[#C9A227] leading-tight">
                      {headerData["assemblyData"]["model_description"]}
                    </h3>
                  )}

                  {fetchingHeaderData ? (
                    <div className="mb-5 w-full">
                      <LPskeletonLoading max_width="max-w-md" />
                      <LPskeletonLoading max_width="max-w-sm" />
                    </div>
                  ) : (
                    <p className="mb-5 max-w-[60ch] text-[15.5px] leading-relaxed text-[#C3CCDB]">
                      {headerData["assemblyData"]["description"]}
                    </p>
                  )}

                  <div className="flex flex-wrap gap-3 mb-5">
                    <div className="border border-[#33425E] px-4 py-2.5 min-w-[140px]">
                      <span className="block text-[11px] tracking-widest text-[#9FAABE] font-bold">SERIAL NO</span>
                      {fetchingHeaderData ? (
                        <LPskeletonLoading />
                      ) : (
                        <b className="block font-mono text-[17px] mt-0.5">
                          {headerData["modsData"]["serial_number"]}
                        </b>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2.5">
                    <button
                      type="button"
                      onClick={() => setActiveTab("parts")}
                      className="bg-[#C9A227] hover:bg-[#A8871B] text-[#0B1526] font-bold text-sm px-4 py-3"
                    >
                      Request a parts quote
                    </button>
                    <a
                      href="tel:5123523694"
                      className="bg-transparent border border-[#33425E] hover:border-white text-white font-bold text-sm px-4 py-3"
                    >
                      Call service — 512-352-3694
                    </a>
                  </div>

                  <div className="sm:hidden mt-4">
                    <button
                      type="button"
                      className="flex items-center bg-[#C9A227] px-4 py-2 rounded-none w-fit text-[#0B1526]"
                      onClick={() => setSendDesktopLink(true)}
                    >
                      <p className="text-sm cursor-pointer font-semibold">
                        Continue This Session On My Computer
                      </p>
                      <span className="w-6 h-6"><RightArrowIcon /></span>
                    </button>
                  </div>
                </div>

                <div className="hidden lg:block bg-white border border-[#D9DDE6] p-3 text-center">
                  {fetchingHeaderData ? (
                    <div className="bg-gray-200 w-full aspect-square"> </div>
                  ) : (
                    <img
                      src={`data:image/png;base64,${headerData["qrData"]["base64_string"]}`}
                      alt={`QR code for EQID ${headerData["modsData"]["serial_number"]}`}
                      className="w-full h-auto block"
                    />
                  )}
                  {fetchingHeaderData ? (
                    <span className="block w-fit mx-auto mt-2">
                      <LPskeletonLoading />
                    </span>
                  ) : (
                    <b className="block mt-2.5 font-mono text-[15px] text-[#131F38]">
                      {headerData["modsData"]["serial_number"]}
                    </b>
                  )}
                  <span className="block text-[10.5px] tracking-widest text-[#5B6679] font-bold mt-0.5">
                    SCAN ON MACHINE
                  </span>
                </div>
              </div>
            </div>

            <div className="px-6 md:px-8 py-5 border-b border-[#E8EBF1]">
              <h3 className="m-0 mb-1 text-[19px] font-bold text-[#131F38]">Documentation for this machine</h3>
              <p className="m-0 text-sm text-[#5B6679]">
                {serialNumber ? `Everything below is matched to serial ${serialNumber} — parts pages, drawings, manuals and tutorials as built.` : ""}
              </p>
            </div>
            {!fetchingHeaderData && <LPviewByDocument modsId={modsId} />}

            <LPcontactUsForm eqid_link={qr_id} />
          </section>
        </div>
      )}

      {activeTab === "parts" && (
        <div className="max-w-[1280px] mx-auto px-4 pb-16 pt-6">
          <EqidPartsStore serialNumber={serialNumber} modsId={modsId} />
        </div>
      )}

      {sendDesktopLink && (
        <Popup>
          <form className="pt-2 pb-6">
            <p className="text-lg mb-2">
              Please enter your email address to receive the EQID page URL.
            </p>
            <InputField
              className="w-full"
              placeholder={"Enter Email Address"}
              onChange={(e) => handleChange(e.target.value)}
              errorMessage={error}
              value={urlEmail}
            />
            <div className="flex gap-4 mt-3">
              <ButtonOutline
                className={"w-full"}
                onClick={() => { setSendDesktopLink(false); setError(""); setUrlEmail(""); setInitialSubmit(true) }}
                buttonText={"Cancel"}
                disabled={sendingData}
              />
              <ButtonSolid className={"w-full"} onClick={emailSubmit} disabled={sendingData} buttonText={sendingData ? "Sending..." : "Submit"} />
            </div>
          </form>
        </Popup>
      )}
    </main>
  );
}

export default LandingPage;
